import booker from 'booker/src/resources'

// eslint-disable-next-line 
export default {
   "en-us": Object.assign({},
      booker['en-us'],
   )
};
